import React from 'react';
import Image from 'next/legacy/image';
import {
  Card,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from '@mui/material';

import { TrustpilotReview } from '@kamernet/core/ApiClient/Kamernet';
import TrustPilot from './images/TrustpilotLogo.webp';

import styles from './TrustpilotReview.module.css';

export type TrustpilotReviewCardProps = TrustpilotReview;

export const TrustpilotReviewCard = ({
  text,
  userName,
  reviewDate,
}: TrustpilotReviewCardProps) => {
  return (
    <Card className={styles.root}>
      <CardMedia className={styles.cardMedia}>
        <Rating
          className={styles.rating}
          name="size-small"
          defaultValue={5}
          size="small"
          readOnly
        />
        <Image
          src={TrustPilot.src}
          alt="Trustpilot user review"
          width={60}
          height={16}
        />
      </CardMedia>
      <CardContent className={styles.cardContent}>
        <Typography variant="body2">{text}</Typography>
        <div className={styles.reviewFooter}>
          <Typography>{userName}</Typography>
          <div> - </div>
          <Typography color="text.secondary">{reviewDate}</Typography>
        </div>
      </CardContent>
    </Card>
  );
};
